import React, { useState, useEffect } from 'react';
import { TABS } from '../utils/constants';

export default function Navigation({ activeTab, setActiveTab, user }) {
  const [reportingDropdownOpen, setReportingDropdownOpen] = useState(false);
  const [editDropdownOpen, setEditDropdownOpen] = useState(false);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const reportingDropdown = document.querySelector('.reporting-dropdown-container');
      const editDropdown = document.querySelector('.edit-dropdown-container');
      
      const clickedInsideReporting = reportingDropdown && reportingDropdown.contains(event.target);
      const clickedInsideEdit = editDropdown && editDropdown.contains(event.target);
      
      if (!clickedInsideReporting && reportingDropdownOpen) {
        setReportingDropdownOpen(false);
      }
      
      if (!clickedInsideEdit && editDropdownOpen) {
        setEditDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [reportingDropdownOpen, editDropdownOpen]);

  const dropdownItemStyle = {
    display: 'block',
    width: '100%',
    padding: '8px 12px',
    textAlign: 'left',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer'
  };

  const dropdownStyle = {
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: 'white',
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    zIndex: 10,
    minWidth: 180,
    maxWidth: 'calc(100vw - 24px)'
  };

  return (
    <>
      <div style={{ display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        {/* Reporting Dropdown */}
        <div style={{ position: 'relative' }} className="reporting-dropdown-container">
          <button 
            className={`secondary-button ${[TABS.REPORTS, TABS.DIGEST, TABS.REQUESTS, TABS.REFERRALS, TABS.PROBATION_EXPIRIES, TABS.ONBOARDING_OVERVIEW, TABS.DISMISSED].includes(activeTab) ? 'active' : ''}`}
            onClick={() => setReportingDropdownOpen(!reportingDropdownOpen)}
            style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          >
            Reporting ▼
          </button>
          {reportingDropdownOpen && (
            <div style={dropdownStyle}>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.REPORTS ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.REPORTS);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.REPORTS ? '#F0EDE6' : 'transparent'}
              >
                Time-Off Reports
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.DISMISSED ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.DISMISSED);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.DISMISSED ? '#F0EDE6' : 'transparent'}
              >
                Dismissed
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.REQUESTS ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.REQUESTS);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.REQUESTS ? '#F0EDE6' : 'transparent'}
              >
                Time Off List
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.DIGEST ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.DIGEST);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.DIGEST ? '#F0EDE6' : 'transparent'}
              >
                Slack Digest
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.REFERRALS ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.REFERRALS);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.REFERRALS ? '#F0EDE6' : 'transparent'}
              >
                Referrals
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.PROBATION_EXPIRIES ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.PROBATION_EXPIRIES);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.PROBATION_EXPIRIES ? '#F0EDE6' : 'transparent'}
              >
                Probation Expiries
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.ONBOARDING_OVERVIEW ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.ONBOARDING_OVERVIEW);
                  setReportingDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.ONBOARDING_OVERVIEW ? '#F0EDE6' : 'transparent'}
              >
                Onboarding Overview
              </button>
            </div>
          )}
        </div>

        {/* Edit Dropdown */}
        <div style={{ position: 'relative' }} className="edit-dropdown-container">
          <button 
            className={`secondary-button ${[TABS.EMPLOYEES, TABS.POLICIES, TABS.ADJUSTMENTS, TABS.ONBOARDING, TABS.PROBATION_POLICIES].includes(activeTab) ? 'active' : ''}`}
            onClick={() => setEditDropdownOpen(!editDropdownOpen)}
            style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          >
            Edit ▼
          </button>
          {editDropdownOpen && (
            <div style={dropdownStyle}>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.EMPLOYEES ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.EMPLOYEES);
                  setEditDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.EMPLOYEES ? '#F0EDE6' : 'transparent'}
              >
                Employees
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.POLICIES ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.POLICIES);
                  setEditDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.POLICIES ? '#F0EDE6' : 'transparent'}
              >
                Policies
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.ADJUSTMENTS ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.ADJUSTMENTS);
                  setEditDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.ADJUSTMENTS ? '#F0EDE6' : 'transparent'}
              >
                Balance Adjustments
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.ONBOARDING ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.ONBOARDING);
                  setEditDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.ONBOARDING ? '#F0EDE6' : 'transparent'}
              >
                Onboarding
              </button>
              <button 
                style={{
                  ...dropdownItemStyle,
                  background: activeTab === TABS.PROBATION_POLICIES ? '#F0EDE6' : 'transparent'
                }}
                onClick={() => {
                  setActiveTab(TABS.PROBATION_POLICIES);
                  setEditDropdownOpen(false);
                }}
                onMouseEnter={(e) => e.target.style.background = '#F0EDE6'}
                onMouseLeave={(e) => e.target.style.background = activeTab === TABS.PROBATION_POLICIES ? '#F0EDE6' : 'transparent'}
              >
                Probation Policies
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
} 